"use client"

import {useEffect, useState} from 'react';
import {useAppStore} from "@/store/AppStore";
import {WalkStatus} from "@/types/Walk";

const useWalkData = () => {
  const loadWalkStatus = useAppStore((state) => state.loadWalkStatus);
  const user = useAppStore((state) => state.user);
  const [data, setData] = useState<WalkStatus | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      if (!user?.access_token) {
        return false
      }
      const fetched = await loadWalkStatus(user?.access_token)
      if (fetched) {
        setData(fetched);
      }
    }
    if (!data) {
      fetchData();
    }
  }, [data, loadWalkStatus, user?.access_token]);

  return data;
};

export default useWalkData;
